import React, { useEffect, useState } from 'react'
import {
  Box,
  Flex, Input,
  Menu,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs, Text,
  MenuButton,
  Button,
  useToast
} from "@chakra-ui/react";
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckCloseButton from '../../../global/components/helper-components/components/LaunchdeckCloseButton';
import { displayReactIcon } from '../../helpers/dsr-display-helpers';
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import FormFieldCharactersRemaining from '../../../forms/TextInputField/components/FormFieldCharactersRemaining';
import { IoChevronDownOutline } from 'react-icons/io5';
import LaunchdeckSwitch from '../../../global/components/helper-components/components/LaunchdeckSwitch';


export const CustomPageSettingsModal = ({
  pageId,
  showModal,
  pageIcon,
  pageIconColor,
  pageTitle,
  pageDescription,
  displayPage,
  lockedPage,
  handleClosePageSettingsModal,
  handleRemovePage,
  handleEditPageData,
  handleDuplicatePageClick,
  dsrBrandingOptions
}) => {

  const iconSelectionArray = ["customised-page", "circle-check", "folder", "star"]
  const [pageSettingsState, setPageSettingsState] = useState({
    pageName: pageTitle ? pageTitle : '',
    customPageDescription: pageDescription ? pageDescription : '',
    isPageVisible: displayPage,
    isPageLocked: lockedPage ? lockedPage : false
  });
  const [chosenIcon, setChosenIcon] = useState(pageIcon ? pageIcon : 'customised-page')
  const toast = useToast()
  const [chosenIconColor, setChosenIconColor] = useState("");
  const [brandColors, setBrandColors] = useState({})
  const [error, setError] = useState('');

  const nameCharacterLimit = 50;
  const descriptionCharacterLimit = 280;

  useEffect(() => {
    if (displayPage !== pageSettingsState.isPageVisible) {
      setPageSettingsState(prevState => ({
        ...prevState,
        isPageVisible: displayPage
      }))
    }

    if (displayPage !== pageSettingsState.isPageLocked) {
      setPageSettingsState(prevState => ({
        ...prevState,
        isPageLocked: lockedPage
      }))
    }
  }, [displayPage, lockedPage]);

  useEffect(() => {
    if (pageIconColor) {
      setChosenIconColor(pageIconColor)
    }
  }, [pageIconColor]);

  useEffect(() => {
    if (dsrBrandingOptions) {
      setBrandColors(dsrBrandingOptions)
    }
  }, [dsrBrandingOptions]);


  const handleClickClosePageSettingsModal = () => {
    setError('')
    handleClosePageSettingsModal()
  }

  const onChangeHandler = (event) => {
    setError('')

    setPageSettingsState(prevPageSettings => ({
      ...prevPageSettings,
      [event.target.name]: event.target.value
    }))
  };

  const handleSavePageSettings = () => {
    const { pageName, customPageDescription, isPageVisible, isPageLocked } = pageSettingsState;
    if (pageName.length <= 0) {
      setError('pageName')
      return;
    }

    if (customPageDescription.length > descriptionCharacterLimit) {
      setError('pageDescription')
      return;
    }

    if (!error) {
      let customPageData = {};

      if (pageName !== pageTitle) {
        customPageData.pageTitle = pageName;
      }

      if (customPageDescription !== pageDescription) {
        customPageData.pageDescription = customPageDescription;
      }

      if (isPageVisible !== displayPage) {
        customPageData.displayPage = isPageVisible;
        if (isPageVisible === false) {
          customPageData.lockedPage = false;
        }

      }

      if (isPageLocked !== lockedPage) {
        customPageData.lockedPage = isPageLocked;
      }

      if (Object.keys(customPageData).length > 0) {
        handleEditPageData(customPageData, pageId)
      }

      handleClickClosePageSettingsModal()
    }
  }

  const handlePickIcon = (icon) => {
    const isExpectedIcon = iconSelectionArray.includes(icon)

    if (isExpectedIcon) {
      let customPageData = {
        pageIcon: icon
      };

      if (Object.keys(customPageData).length > 0 && pageId) {
        handleEditPageData(customPageData, pageId)
      }
      setChosenIcon(icon)
    }
  }

  const handlePickIconColor = (color) => {

    if (color) {
      let customPageData = {
        pageIconColor: color
      };

      if (Object.keys(customPageData).length > 0 && pageId) {
        handleEditPageData(customPageData, pageId)
      }
      setChosenIconColor(color)
    }
  }

  const handleClickDeletePageButton = () => {
    // if (confirmDelete) {
    handleRemovePage(pageId)
    // setConfirmDelete(false);
    handleClosePageSettingsModal()
    // } else {
    //   setConfirmDelete(true);
    // }
  };

  const handleClickDuplicatePageButton = () => {
    handleDuplicatePageClick(pageId)
    handleClosePageSettingsModal()

    toast(
      triggerLaunchdeckToast({
        useCase: "work-in-progress-state",
        label: `${pageTitle} is being duplicated`,
        isMobileView: false
      })
    )
  }

  // const cancelButton = (
  //   <LaunchdeckButton bg='gray.500' color='white' onClick={() => handleClickClosePageSettingsModal(false)} px='0.5em' label='Cancel' />
  // )

  return (
    <Modal isOpen={showModal} closeOnOverlayClick={false} isCentered={true} preserveScrollBarGap={true} >
      <ModalOverlay />
      <ModalContent display="inline-block" rounded='0.25em' minW={['90%', '500px']} maxW='700px' h='auto'>
        <ModalBody px='0em'>
          <Flex justify='space-between' align='center' w='100%'>
            <Flex px='1.5em' py='0.5em' justify='flex-start' align='center' ml='0.5em'>
              <Box fontSize='1.25em' lineHeight='1.375em' color='brandDark.500'>Page settings</Box>
            </Flex>
            <Box pr='1.5em' display='flex' alignItems='center'>
              <LaunchdeckCloseButton handleCloseModal={handleClickClosePageSettingsModal} />
            </Box>
          </Flex>

          <Flex direction='column' justify='space-around' alignItems='center' w='100%'>
            <Box width='100%'>
              <Tabs width='100%'>
                <TabList padding='0 24px'>
                  <Tab fontSize='0.875em' pr='1em'>General</Tab>
                  <Tab fontSize='0.875em' px='1em'>Duplicate page</Tab>
                  {/* <Tab isDisabled={true}    >Template settings</Tab> */}
                  <Tab fontSize='0.875em' px='1em'>Delete page</Tab>
                </TabList>

                <TabPanels padding='24px'>
                  <TabPanel>
                    <Box margin='0 -10px' minHeight='380px'>
                      <Box px='1em'>
                        <Box mb='24px'>
                          <Flex w='100%' justify='space-between' align='center' mb='10px'>
                            <Box fontSize='0.875em'>Page name<Box as='span' color='brandPink.500'>*</Box></Box>
                            <Box>
                              <FormFieldCharactersRemaining
                                currentValue={pageSettingsState.pageName}
                                characterLimit={nameCharacterLimit}
                              />
                            </Box>
                          </Flex>
                          <Input
                            name='pageName'
                            value={pageSettingsState.pageName}
                            onChange={onChangeHandler}
                            placeholder="Enter page name"
                            maxLength={nameCharacterLimit}
                            borderColor={error === 'pageName' ? 'brandPink.500' : ""}
                            mb='0.2em'
                            h='1.4em'
                            fontSize='0.875em'
                            fontWeight='400'
                            color='brandDark.500'
                            border='1px solid #A0AEC0'
                            borderRadius='4px'
                            padding='16px'
                          />
                          {error === 'pageName' && <Text color='brandPink.500' fontSize='0.8em'>Give your page a name</Text>}
                        </Box>

                        <Box mb='24px'>
                          <Box w='100%' mb='10px'>
                            <Box fontSize='0.875em'>Icon</Box>
                            <Flex gap={4}>

                              <Flex gap={4} mt='0.5em' w='100%'>
                                {iconSelectionArray?.map(icon => {
                                  const isChosenIcon = chosenIcon === icon ? true : false;
                                  const iconColor = isChosenIcon ? 'brandDark.500' : 'gray.500'
                                  return (
                                    <Flex key={`page-icon-${icon}`} cursor='pointer' onClick={() => handlePickIcon(icon)} border='1px solid' bg={isChosenIcon && 'brand.50'} borderColor={isChosenIcon ? 'brand.500' : 'gray.200'} rounded='0.5em' justify='center' align='center' p='0.5em'>
                                      {displayReactIcon(icon, '1.5em', "", "", iconColor)}
                                    </Flex>
                                  )
                                })}
                              </Flex>

                              <Menu closeOnSelect={true} placement="bottom-end">
                                <MenuButton
                                  as={Button}
                                  w="10em"
                                  fontSize="14px"
                                  padding="16px 12px"
                                  background="rgba(255, 255, 255, 0.92)"
                                  border="1px solid #CBD5E0"
                                  rounded='1em'
                                  {...{
                                    rightIcon: <IoChevronDownOutline />
                                  }}
                                >


                                  <Flex gap={4} justify='flex-start' align='center' >
                                    <Box display='flex' boxSize='1em' rounded="full" border='1px solid' borderColor='gray.200' bg={chosenIconColor || 'gray.500'} />
                                    <Box fontSize='0.8em'>{chosenIconColor && chosenIconColor === 'brandDark.500' ? "Default" : "Custom"}</Box>
                                  </Flex>
                                </MenuButton>
                                <MenuList>
                                  <MenuItem name='brandDark.500' className='filter-menu__dropdown-option-display' onClick={() => handlePickIconColor('brandDark.500')}>
                                    <Flex flex='1' gap={4} align='center' justify='flex-start' >
                                      <Box boxSize='1em' rounded='50%' bg='brandDark.500' />
                                      <Box fontSize='0.8em'>Default</Box>
                                    </Flex>

                                  </MenuItem>

                                  {brandColors.primaryColor &&
                                    <MenuItem name={brandColors.primaryColor} className='filter-menu__dropdown-option-display' onClick={() => handlePickIconColor(brandColors.primaryColor)}>
                                      <Flex flex='1' gap={4} align='center' justify='flex-start' >
                                        <Box boxSize='1em' rounded='50%' border='1px solid' borderColor='gray.200' bg={brandColors.primaryColor} />
                                        <Box fontSize='0.8em'>Brand color</Box>
                                      </Flex>
                                    </MenuItem>
                                  }

                                  {brandColors.secondaryColor &&
                                    <MenuItem name={brandColors.secondaryColor} className='filter-menu__dropdown-option-display' onClick={() => handlePickIconColor(brandColors.secondaryColor)}>
                                      <Flex flex='1' gap={4} align='center' justify='flex-start' >
                                        <Box boxSize='1em' rounded='50%' border='1px solid' borderColor='gray.200' bg={brandColors.secondaryColor} />
                                        <Box fontSize='0.8em'>Accent color</Box>
                                      </Flex>
                                    </MenuItem>
                                  }
                                </MenuList>
                              </Menu>
                            </Flex>

                          </Box>
                        </Box>


                        {/* <Box mb='24px'>
                          <Flex w='100%' justify='space-between' align='center' mb='10px'>
                            <Box fontSize='0.875em'>Page description</Box>
                            <Box display='flex' fontSize='0.875em'>
                              <Box fontWeight='600'>{pageSettingsState.customPageDescription.trim().length}</Box>/{descriptionCharacterLimit}
                            </Box>
                          </Flex>
                          <InputTextAreaExpandable
                            name='customPageDescription'
                            onChangeHandler={onChangeHandler}
                            // inputValue={noteContent}
                            maxLength={descriptionCharacterLimit}
                            inputValue={pageSettingsState.customPageDescription}
                            border="1px solid"
                            borderColor='gray.400'
                            placeholder={"A short explanation about this page. This internal note is only available to you and your team."}
                          />
                          {error === 'pageDescription' && <Text color='brandPink.500' fontSize='0.8em'>Maximum {descriptionCharacterLimit} characters</Text>}
                        </Box> */}

                        <Box mb='24px'>
                          <Flex w='100%' justify='space-between' align='center' mb='10px'>
                            <Box fontSize='0.875em'>Page visible</Box>
                            <Box display='flex' fontSize='0.875em'>
                              <Box>
                                <LaunchdeckSwitch
                                  name="isPageVisible"
                                  isChecked={pageSettingsState.isPageVisible} 
                                  onChange={(event) => setPageSettingsState({
                                    ...pageSettingsState,
                                    isPageVisible: event.target.checked,
                                    ...(event.target.checked === false && { isPageLocked: false })
                                  })}
                                  yesContent='"Yes"'
                                  noContent='"No"'
                                />
                              </Box>
                            </Box>
                          </Flex>
                        </Box>

                        <Box mb='24px'>
                          <Flex w='100%' justify='space-between' align='center' mb='10px'>
                            <Box fontSize='0.875em'>Page locked</Box>
                            <Box display='flex' fontSize='0.875em'>
                              <Box>
                              <LaunchdeckSwitch
                                  name="isPageLocked"
                                  isChecked={pageSettingsState.isPageLocked} 
                                  onChange={(event) => setPageSettingsState({
                                    ...pageSettingsState,
                                    isPageLocked: event.target.checked
                                  })}
                                  yesContent='"Lock"'
                                  noContent='""'
                                  yesBg="brandDark.500"
                                  noBg=""
                                />

                              </Box>
                            </Box>
                          </Flex>
                        </Box>
                      </Box>
                    </Box>
                    <Flex w='100%'>
                      <Flex align='center' justify='flex-end' w='100%'>
                        <LaunchdeckButton bg='brandDark.500' color='white' onClick={handleSavePageSettings} px='0.5em' label='OK' />

                      </Flex>
                    </Flex>
                  </TabPanel>

                  <TabPanel>
                    <Box margin='0px -10px' minHeight='380px' height='100%'>
                      <Flex height='100%' minHeight='380px' justifyContent='center' alignItems='center' flexDirection='column'>
                        <Box fontSize='20px' fontWeight='600'>Duplicate page</Box>
                        <Box maxWidth='27em' mb='1.5em' mt='1em' textAlign='center' color='#2D3748' fontSize='0.875em'>
                          An exact copy of <strong>{pageTitle}</strong> will be created. Proceed?
                        </Box>
                        <Flex justifyContent='center' m='24px' width='100%' maxWidth='430px'>
                          <Box
                            display='flex'
                            justifyContent='center'
                            cursor='pointer'
                            alignItems='center'
                            onClick={handleClickDuplicatePageButton}
                            width='100%'
                            height='40px'
                            borderRadius='300px'
                            backgroundColor={'brandDark.500'}
                          >
                            <Flex
                              color={'white'}
                              fontSize='0.875em'
                              align='center'
                              gap={4}
                            >
                              {displayReactIcon('add-new-page', '1em')}
                              Duplicate page
                            </Flex>
                          </Box>
                        </Flex>
                      </Flex>
                    </Box>
                  </TabPanel>
                  <TabPanel >
                    <Box margin='20px -10px' minHeight='380px' height='100%'>
                      <Flex height='100%' minHeight='380px' justifyContent='center' alignItems='center' flexDirection='column'>
                        <Box fontSize='20px' fontWeight='600'>Remove page</Box>
                        <Box maxWidth='27em' mb='1.5em' mt='1em' textAlign='center' color='#2D3748' fontSize='0.875em'>
                          <i>{pageTitle}</i> and its content will be removed from this Room. Are you sure?
                        </Box>
                        <Flex justifyContent='center' m='24px' width='100%' maxWidth='430px'>
                          <Box
                            display='flex'
                            justifyContent='center'
                            cursor='pointer'
                            alignItems='center'
                            onClick={handleClickDeletePageButton}
                            width='100%'
                            height='40px'
                            borderRadius='300px'
                            backgroundColor={'brandPink.500'}
                          // backgroundColor={confirmDelete ? 'brandPink.500' : '#da37391a'}
                          >
                            <Flex
                              color={'white'}
                              fontSize='0.875em'
                              align='center'
                              gap={4}
                            >
                              {displayReactIcon('remove', '1em')}
                              Yes, remove this page
                              {/* {!confirmDelete
                                ? 'Delete page permanently'
                                : 'Click one more time to confirm'
                              } */}
                            </Flex>
                          </Box>
                        </Flex>
                      </Flex>
                    </Box>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
